import React from 'react';
import FuseAnimate from '@fuse/core/FuseAnimate';
//import { useForm } from '@fuse/hooks';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { Link } from 'react-router-dom';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import InputBase from '@material-ui/core/InputBase';
import { Input, List, ListItem, ListItemText } from '@material-ui/core'
import { useDispatch } from 'react-redux';
import {submitRegister} from '../../../../auth/store/actions';
import HeaderAuth from 'app/main/pages/auth/headerAuth/HeaderAuth'; 
import {useTranslation} from 'react-i18next';
import clsx from 'clsx';

const BootstrapInput = withStyles((theme) => ({
	input: {
		borderRadius: 0,
		position: 'relative',
		backgroundColor: "#fff",
		border: '1px solid #ced4da',
		fontSize: 16,
		padding: '10px 26px 10px 12px',
		'&:focus': {
			borderColor: '#fff',
		}
	},
}))(InputBase);

const useStyles = makeStyles(theme => ({
	root: {
		background: `radial-gradient(${theme.palette.background.paper} 100%, ${theme.palette.background.paper} 100%)`,
		color: theme.palette.primary.contrastText
	},
	containerLogin: {
		boxShadow: 'none',
		maxWidth: '600px',
		margin: 'auto',
		fontSize: '14px'
	},
	logo: {
		width: '100%',
		marginBottom: '12px'
	},
	listItem: {
		display: 'flex',
		justifyContent: 'space-between',
	},
	input: {
		border: '1px solid #ced4da',
		padding: 10,
		width: 400,
	},
	inputSelect: {
		borderRadius: 0,
		position: 'relative',
		backgroundColor: "#fff",
		border: '1px solid #ced4da',
		fontSize: 16,
		padding: '10px 26px 10px 12px',
		'&:focus': {
			borderColor: '#fff',
		}
	},
	formControl: {
		marginBottom: '12px'
	},
	button: {
		width: '100%',
		backgroundColor: '#6ba586',
		color: 'white',
		'&:hover': {
			color: 'black'
		}
	},
	signIn: {
		display: 'flex',
	},
	signInLink:{
		color:`${theme.palette.scaiPro.primary}!important`,
	},
	register:{
		fontSize:'3rem',
		fontWeight:'bold',
		color: theme.palette.scaiPro.primary,
	}
}));

function RegisterPage() {
	const dispatch = useDispatch();
	const classes = useStyles();
	const {t} = useTranslation('auth');

	function handleSubmit(ev) {
		ev.preventDefault();
		dispatch(submitRegister({ name: state.name,
						 email: state.email,
						 affiliation: state.affiliation,
						 position: state.position,
						 groupType: state.groupType,
						 password: state.password,
						 password_cnf: state.password_cnf,
						}));
	}

	const [state, setState] = React.useState({
		name: '',
		email: '',
		affiliation: '0',
		position: '0',
		groupType: '3784f046-28d1-46aa-946e-b996d779df31',
		password: '',
		password_cnf: ''
	});

	const handleChange = (event) => {
		const name = event.target.name;
		setState({
			...state,
			[name]: event.target.value,
		});
	};

	return (
		<>
			<HeaderAuth />
			<div className={clsx(classes.root, 'flex flex-col flex-auto flex-shrink-0 items-center justify-center p-32')}>
				<div className="flex flex-col items-center justify-center w-full">
					<FuseAnimate /*animation="transition.expandIn"*/>
						<Card className={clsx(classes.containerLogin, 'w-full max-w-640')}>
							<CardContent className="flex flex-col items-center justify-center p-32">
								{/* <img className={classes.logo} src="assets/images/logos/scai_logo.svg" alt="SCAI logo" /> */}
								<span className={classes.register}>{t('register')}</span>
								<form
									name="registerForm"
									className="flex flex-col justify-center w-full"
									onSubmit={handleSubmit}
								>
									<List>
										<ListItem className={classes.listItem}>
											<ListItemText primary={t("name")} />
											<Input
												required
												disableUnderline
												placeholder={t("enter_name")}
												inputProps={{ className: classes.input }}
												name="name"
												onChange={handleChange}
											/>
										</ListItem>
										<ListItem className={classes.listItem}>
											<ListItemText primary={t("email_id")} />
											<Input
												required
												disableUnderline
												placeholder={t("enter_email")}
												inputProps={{ className: classes.input }}
												name="email"
												type="email"
												onChange={handleChange}
											/>
										</ListItem>
										<ListItem className={classes.listItem}>
											<ListItemText primary={t("affiliation")} />
											<Select
												style={{ width: 422 }}
												labelId="demo-customized-select-label"
												id="demo-customized-select"
												name="affiliation"
												input={<BootstrapInput />}
												onChange={handleChange}
												value={state.affiliation}
											>

												<MenuItem value="0">
													<em>{t('select_affiliation')}</em>
												</MenuItem>
												<MenuItem value='Head Office'>{t('head_office')}</MenuItem>
												<MenuItem value='Branch Office'>{t('branch_office')}</MenuItem>
												<MenuItem value='Site Office'>{t('site_office')}</MenuItem>
											</Select>
										</ListItem>
										<ListItem className={classes.listItem}>
											<ListItemText primary={t("position")} />
											<Select
												style={{ width: 422 }}
												labelId="demo-customized-select-label"
												id="demo-customized-select"
												name="position"
												input={<BootstrapInput />}
												onChange={handleChange}
												value={state.position}
											>
												<MenuItem value="0">
													<em>{t('select_position')}</em>
												</MenuItem>
												<MenuItem value='7c5b9e5d-820f-4d04-aef7-a89ee7de7648'>{t('統括所長')}</MenuItem>
												<MenuItem value='f21b599b-259e-448e-866c-ad39b618c056'>{t('project_manager')}</MenuItem>
												<MenuItem value='2e189a6f-9334-439f-8c23-fb658404c24d'>{t('副所長1')}</MenuItem>
												<MenuItem value='a1779217-75fb-455c-82c1-8e8833b7ccbe'>{t('課長1_現場')}</MenuItem>
												<MenuItem value='ee5ba849-181d-4f27-a832-e609abba5d08'>{t('副所長2')}</MenuItem>
												<MenuItem value='0116325b-e1f7-487d-b522-258e33ee40b2'>{t('課長_現場')}</MenuItem>
												<MenuItem value='b404f356-e4aa-4946-8abe-2b70302124a3'>{t('主任1_現場')}</MenuItem>
												<MenuItem value='638a9247-4a7a-4b3d-94fc-7ca8720281c4'>{t('主任2_現場')}</MenuItem>
												<MenuItem value='54811d53-ee87-4844-9182-da205bac79fd'>{t('係_現場')}</MenuItem>
												<MenuItem value='b0eb8f02-75d5-4a00-93fa-a82fd34cb8b2'>{t('支店_Branch')}</MenuItem>
												<MenuItem value='a9029c2f-8b56-4e94-a059-c409805f9cc5'>{t('Other')}</MenuItem>
											</Select>
										</ListItem>
										<ListItem className={classes.listItem}>
											<ListItemText primary={t("group_type")}/>
											<Select
												style={{ width: 422 }}
												labelId="demo-customized-select-label"
												id="demo-customized-select"
												name="groupType"
												input={<BootstrapInput />}
												onChange={handleChange}
												value={state.groupType}
											>
												<MenuItem value='MO Staff'>{t('mo_staff')}</MenuItem>
											</Select>
										</ListItem>
										<ListItem className={classes.listItem}>
											<ListItemText primary={t("new_password")} />
											<Input
												disableUnderline
												type="password"
												required
												placeholder={t("enter_password")}
												inputProps={{ className: classes.input }}
												name="password"
												onChange={handleChange}
											/>
										</ListItem>
										<ListItem className={classes.listItem}>
											<ListItemText primary={t("confirm_new_password")} />
											<Input
												disableUnderline
												type="password"
												placeholder={t("confirm_new_password")}
												inputProps={{ className: classes.input }}
												required
												name="password_cnf"
												onChange={handleChange}
											/>
										</ListItem>
										<ListItem>
											<Button className="bt-submit" type="submit">
												{t('submit')}
											</Button>
										</ListItem>
									</List>
								</form>
								<div>
									<Typography className={classes.signIn}>
										{t('already_have_an_account')}
										<Link className={clsx("font-medium ml-10", classes.signInLink)} to="/login">
											{t('sign_in')}
										</Link>
									</Typography>
								</div>
							</CardContent>
						</Card>
					</FuseAnimate>
				</div>
			</div>
		</>
	);
}

export default RegisterPage;
